module.exports = __webpack_public_path__ + "img/ekyc_frame_poa_1.426e08e9.svg";